//内容区的整体块样式 线上数据和本地数据 线性[51, 56] 国风[50, 55]的id不同，做了兼容
export const posterMap = {
  tagId: 0,
  backgroundId: 0,
  elementId: 0,
  textStyleId: 0,
  sizeId: 0,
  type: 0,
  sizeName: "",
  // 文案 从第一行文字开始，第9个是二维码，第10个是顶部的logo名称
  textValue: ["", "", "", "", "", "", "", "", "", "", ""],
  elementTypeId: 2,
  size: {
    width: 375,
    height: 667,
  },
  bgParameter: {},
  elementImg: "",
  elementInfo: {
    elementWidth: 375,
    elementHeight: 500,
    offsetX: -1,
    offsetY: 0,
    remainPart: 1,
  },
  textInfo: {
    textPositionX: -1,
    textPositionY: 57,
    textAlignType: 0,
    lineCount: 2,
  },
  // 文案样式，对应textValue属性的文字样式，第三行对应的是内容去方框样式
  textStyle: [],
};
// poster文字样式
export const mainTextStyles = [
  {
    name: "副标题",
    enName: "subtitle",
    isVali: true,
    isSensitive: false,
    isMenu: false,
    labelStyle: "样式1",
    showLabelStyle: false,
    optionalStyleName: "labelStyleMap",
  },
  {
    name: "主标题",
    enName: "head-title",
    isVali: true,
    isSensitive: false,
    isMenu: false,
    labelStyle: "样式1",
    showLabelStyle: false,
    optionalStyleName: "labelStyleMap",
  },
  {
    name: "内容标题",
    enName: "contentTitle",
    isVali: true,
    isSensitive: false,
    isLabelStyle: 1,
    labelStyle: "poster-style-1",
    showLabelStyle: true,
    max: 8,
    min: 4,
  },
  {
    name: "内容1",
    enName: "item1",
    isVali: true,
    isSensitive: false,
    isMenu: false,
    isLabelStyle: 1,
    labelStyle: "icon5",
    showLabelStyle: true,
    optionalStyleName: "iconStyleMap",
    max: 14,
    min: 6,
  },
  {
    name: "内容2",
    enName: "item2",
    isVali: true,
    isSensitive: false,
    labelStyle: "icon5",
    showLabelStyle: true,
    max: 14,
    min: 6,
  },
  {
    name: "内容3",
    enName: "item3",
    isVali: true,
    isSensitive: false,
    labelStyle: "icon5",
    showLabelStyle: true,
    max: 14,
    min: 6,
  },
  {
    name: "内容4",
    enName: "item4",
    isVali: true,
    isSensitive: false,
    labelStyle: "icon5",
    showLabelStyle: true,
    max: 14,
    min: 6,
  },
  {
    name: "底部标题",
    enName: "linkName",
    isVali: true,
    isSensitive: false,
    max: 24,
    min: 14,
  },
  {
    name: "引导文案",
    enName: "tip",
    isVali: true,
    isSensitive: false,
    max: 10,
    min: 8,
  },
  {
    name: "二维码",
    enName: "qrCode",
    isVali: true,
    isSensitive: false,
    max: 100,
    min: 1,
  },
  {
    name: "站点logo",
    enName: "logo",
    isVali: true,
    isSensitive: false,
    max: 20,
    min: 6,
  },
];
// poster的内容区icon样式
export const iconStyleMap = {
  1: {
    id: "1",
    name: "icon1",
    style: {
      width: "24px",
      height: "24px",
      borderRadius: "100%",
      src: require("./../icon/icon1.png"),
    },
  },
  2: {
    id: "2",
    name: "icon2",
    style: {
      width: "24px",
      height: "24px",
      borderRadius: "100%",
      src: require("./../icon/icon2.png"),
    },
  },
  3: {
    id: "3",
    name: "icon3",
    style: {
      width: "24px",
      height: "24px",
      borderRadius: "100%",
      src: require("./../icon/icon3.png"),
    },
  },
  4: {
    id: "4",
    name: "icon4",
    style: {
      width: "24px",
      height: "24px",
      borderRadius: "100%",
      src: require("./../icon/icon4.png"),
    },
  },
  5: {
    id: "5",
    name: "icon5",
    style: {
      width: "24px",
      height: "24px",
      borderRadius: "100%",
      hasNumber: true,
      src: require("./../icon/icon5.png"),
    },
  },
};
// poster左上角的logo标识
export const logoOptions = [
  {
    id: 1,
    name: "学科网",
    logos: [
      {
        id: "logo-1",
        name: "学科网",
        src: "https://zxxkstatic.zxxk.com/ued/bar-site-logo/logo-xkw.png",
      },
      {
        id: "logo-2",
        name: "学科网 校长日",
        src: "https://zxxkstatic.zxxk.com/ued/bar-site-logo/logo-master.png",
      },
      {
        id: "logo-3",
        name: "网校通专享",
        src: "https://zxxkstatic.zxxk.com/ued/bar-site-logo/logo-wxt.png",
      },
      {
        id: "logo-4",
        name: "学科网 班主任日",
        src: "https://zxxkstatic.zxxk.com/ued/bar-site-logo/logo-monitor.png",
      },
      {
        id: "logo-5",
        name: "AI职教",
        src: "https://zxxkstatic.zxxk.com/ued/bar-site-logo/logo-ai.png",
      },
      {
        id: "logo-6",
        name: "橙子学",
        src: "https://zxxkstatic.zxxk.com/ued/bar-site-logo/logo-orange.png",
      },
      {
        id: "logo-7",
        name: "学科网 橙子学",
        src: "https://zxxkstatic.zxxk.com/ued/bar-site-logo/logo-xkw-orange.png",
      },
      {
        id: "logo-8",
        name: "组卷网",
        src: "https://zxxkstatic.zxxk.com/ued/bar-site-logo/logo-zujuan.png",
      },
    ],
  },
];
